import { useCreateNewCompanyAndAdmin } from "@/common/api/mutation";
import { useModal } from "@/common/contexts/Modal.context";
import { useGenerateFormElements } from "@/common/hooks";
import { createAIRXAdmin } from "@/common/strategies";
import { queryClient } from "@/common/utils";
import { Button, Form } from "antd";
import { useForm } from "antd/es/form/Form";
import { toast } from "react-toastify";
import Typography from "../Typography/Typography";
import { ROLE } from "@/common/const/types/index.const";

export default function CreateNewAIRXUserModal() {
  const { formElements } = useGenerateFormElements(createAIRXAdmin);
  const { closeModal } = useModal();
  const [form] = useForm();
  const { mutate } = useCreateNewCompanyAndAdmin();
  const onSubmit = (values: any) => {
    const adminInfo = {
      ...values,
      roleID: values.roleID !== ROLE[0] ? 5 : 6,
      location: "",
      companyId: 1,
    };
    mutate(
      { adminInfo },
      {
        onSuccess: () => {
          toast.success("AIRX user created successfully");
          queryClient.invalidateQueries();
          closeModal();
        },
      }
    );
  };
  return (
    <div className="">
      <Typography
        type="p"
        fontFamily="font-kanit"
        fontWeight="font-medium"
        fontSize={24}
        textAlign="center"
        className="capitalize text-center"
      >
        Create new AIRX user
      </Typography>
      <Form form={form} name="create-airx-user" onFinish={onSubmit}>
        <div className="grid grid-cols-2 gap-4 mt-8 w-[576px]">
          {...formElements}
        </div>
        <div className="flex items-center justify-center mt-8">
          <Button
            htmlType="submit"
            type="primary"
            className="min-h-10 font-inter font-semibold mx-auto"
          >
            Crete new AIRX user
          </Button>
        </div>
      </Form>
    </div>
  );
}
